import type { StrapiEndpointId } from './useStrapiApi';
import { useStrapiGet } from './useStrapiApi';
import { useRepo } from 'pinia-orm';
import { Profile } from 'src/modules/User/models/Profile';

type AnyObject = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  id?: number;
  objectId?: string;
};

export function removeIds<T>(data: T, keys?: string[]): T;
export function removeIds(data: AnyObject, keys?: string[]): AnyObject;
export function removeIds<T>(
  data: T,
  keys = ['id', 'objectId'] as string[],
): T | AnyObject {
  // Handle arrays
  if (Array.isArray(data)) {
    return data.map((item) => removeIds(item, keys));
  }

  // If not an object or null, return as is
  if (!data || typeof data !== 'object') {
    return data;
  }

  // Clone the object to avoid modifying the original
  const result: AnyObject = { ...data };

  for (const key of keys) {
    if (key in result) {
      delete result[key];
    }
  }

  // Process nested objects
  for (const key in result) {
    if (result[key] && typeof result[key] === 'object') {
      result[key] = removeIds(result[key], keys);
    }
  }

  return result;
}

export async function retrieveProfile(documentId: string, props = {}) {
  if (!documentId) return;
  const url: StrapiEndpointId = `profiles/${documentId}`;
  const { execute, error, data } = useStrapiGet(url, {
    populate: ['address', 'phone', 'user'],
  });
  await execute();
  const profileRepo = useRepo(Profile);
  Object.assign(props, data.value.data);
  profileRepo.save(props);
  return error.value;
}
